export { default as AddContactIcon } from "./add-contact-s.svg";
export { default as AlertCircleIcon } from "./alert-circle.svg";
export { default as AlertIcon } from "./alert.svg";
export { default as AlertOctagonIcon } from "./alert-octagon.svg";
export { default as AlertTriangleIcon } from "./alert-triangle.svg";
export { default as AllNetworksIcon } from "./all-networks.svg";
export { default as ArrowDownLeftIcon } from "./arrow-down-left.svg";
export { default as ArrowForwardIcon } from "./arrow-forward.svg";
export { default as ArrowLeftCircleIcon } from "./arrow-left-circle.svg";
export { default as ArrowUpRightIcon } from "./arrow-up-right.svg";
export { default as biInfoIcon } from "./biInfoCircle.svg";
export { default as BookIcon } from "./book.svg";
export { default as CheckCircleIcon } from "./check-circle.svg";
export { default as CheckmarkIcon } from "./checkmark.svg";
export { default as ChevronDownIcon } from "./chevron-down.svg";
export { default as ChevronRightIcon } from "./chevron-right.svg";
export { default as CloseIcon } from "./close.svg";
export { default as CodeSandboxIcon } from "./code-sandbox.svg";
export { default as CoinbaseIcon } from "./coinbase.svg";
export { default as CoinIcon } from "./coin.svg";
export { default as ContactIcon } from "./contact-s.svg";
export { default as ContractIcon } from "./contract.svg";
export { default as CopyIcon } from "./copy.svg";
export { default as CrossedCircleIcon } from "./crossed-circle.svg";
export { default as DefaultNFTIcon } from "./default-nft.svg";
export { default as DefaultTokenIcon } from "./default-token.svg";
export { default as DelegateIcon } from "./delegate-s.svg";
export { default as DownloadIcon } from "./download.svg";
export { default as EditIcon } from "./edit.svg";
export { default as EnvelopeIcon } from "./envelope.svg";
export { default as ExternalLinkIcon } from "./external-link.svg";
export { default as EyeIcon } from "./eye.svg";
export { default as EyeOffIcon } from "./eye-off.svg";
export { default as FA12Icon } from "./fa12.svg";
export { default as FA2Icon } from "./fa2.svg";
export { default as FacebookIcon } from "./facebook.svg";
export { default as FileCopyIcon } from "./file-copy.svg";
export { default as FileUploadIcon } from "./file-upload.svg";
export { default as FilterIcon } from "./filter.svg";
export { default as GoogleIcon } from "./google.svg";
export { default as HourglassIcon } from "./hourglass.svg";
export { default as ImportExportIcon } from "./import-export.svg";
export { default as IncomingArrowIcon } from "./incoming-arrow.svg";
export { default as KeyIcon } from "./key.svg";
export { default as LockIcon } from "./lock.svg";
export { default as LoginIcon } from "./login.svg";
export { default as LogoDarkIcon } from "./logo-dark.svg";
export { default as LogoLightIcon } from "./logo-light.svg";
export { default as LogoutIcon } from "./logout.svg";
export { default as MailIcon } from "./mail.svg";
export { default as MenuIcon } from "./menu.svg";
export { default as MoonIcon } from "./moon.svg";
export { default as MoonpayIcon } from "./moonpay.svg";
export { default as MtPelerinIcon } from "./mtPelerin.svg";
export { default as MultisigIcon } from "./multisig.svg";
export { default as OutgoingArrowIcon } from "./outgoing-arrow.svg";
export { default as OutlineQuestionCircleIcon } from "./outline-question-circle.svg";
export { default as PasteIcon } from "./paste.svg";
export { default as PencilIcon } from "./pencil.svg";
export { default as PercentIcon } from "./percent.svg";
export { default as PlusCircleIcon } from "./plus-circle.svg";
export { default as PlusIcon } from "./plus.svg";
export { default as PyramidIcon } from "./pyramid.svg";
export { default as QRCodeIcon } from "./qrcode.svg";
export { default as RadioIcon } from "./radio.svg";
export { default as RedditIcon } from "./reddit.svg";
export { default as RefreshIcon } from "./refresh.svg";
export { default as ReloadIcon } from "./reload.svg";
export { default as RepeatIcon } from "./repeat.svg";
export { default as SafeSendIcon } from "./safe-send.svg";
export { default as SafeSendOnIcon } from "./safe-send-on.svg";
export { default as ScanIcon } from "./scan.svg";
export { default as SearchIcon } from "./search.svg";
export { default as SelectorIcon } from "./selector.svg";
export { default as SettingsIcon } from "./settings.svg";
export { default as ShieldIcon } from "./shield.svg";
export { default as ShieldedIcon } from "./shielded.svg";
export { default as FiShieldIcon } from "./fi-shield.svg";
export { default as SunIcon } from "./sun.svg";
export { default as SwapIcon } from "./swap.svg";
export { default as TagIcon } from "./tag.svg";
export { default as TelegramIcon } from "./telegram.svg";
export { default as TezIcon } from "./tez.svg";
export { default as TezosLogoIcon } from "./tezos-logo.svg";
export { default as TezSolidIcon } from "./tez-solid.svg";
export { default as ThreeDotsIcon } from "./three-dots.svg";
export { default as ThumbsUpIcon } from "./thumbs-up.svg";
export { default as TransakIcon } from "./transak.svg";
export { default as TrashIcon } from "./trash.svg";
export { default as TwitterIcon } from "./twitter.svg";
export { default as WertIcon } from "./wert.svg";
export { default as UnknownIcon } from "./unknown-contact.svg";
export { default as USBIcon } from "./usb.svg";
export { default as UserIcon } from "./user.svg";
export { default as UserPlusIcon } from "./user-plus.svg";
export { default as VerifiedIcon } from "./verified.svg";
export { default as ViewOperationsIcon } from "./view-operations.svg";
export { default as WalletIcon } from "./wallet.svg";
export { default as WhatsAppIcon } from "./whatsapp.svg";
export { default as WindowCloseIcon } from "./window-close.svg";
export { TokenIcon } from "./TokenIcon";

import CloseIcon from "./close.svg";

// This is a temporary icon to replace desktop ones until we migrate components to web
export const StubIcon = CloseIcon;
export * from "./chains";
